import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2937c194")

_pushScopeId("data-v-2937c194")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Exclusive to Prime")
const _hoisted_2 = { class: "pt-8 pb-16 t-center flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "trader_22" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    controls: _withId(() => [
      _createVNode(_component_router_link, {
        custom: "",
        to: "/prime/detail",
        replace: ""
      }, {
        default: _withId(({navigate}) => [
          _createVNode("button", {
            class: "flex-1 btn line",
            onClick: ($event: any) => (_ctx.$emit('close', navigate))
          }, [
            _createVNode(_component_t, {
              path: "live_20",
              custom: ""
            }, {
              default: _withId(({td}) => [
                _createTextVNode(_toDisplayString(td || 'See details'), 1)
              ]),
              _: 1
            })
          ], 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode("button", {
        class: "flex-1 btn primary",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createVNode(_component_t, {
          path: "live_21",
          custom: ""
        }, {
          default: _withId(({td}) => [
            _createTextVNode(_toDisplayString(td || 'OK'), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Pic, {
          src: "membership/not_qualified",
          width: "88",
          height: "88",
          class: "mb-8"
        }),
        _createVNode(_component_t, {
          as: "p",
          path: _ctx.i18nPath,
          args: _ctx.i18nArgs,
          class: "px-16",
          style: {"line-height":"24px"}
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.defaultText), 1)
          ]),
          _: 1
        }, 8, ["path", "args"])
      ])
    ]),
    _: 1
  }))
})